






























































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import { CopyUrl } from "@/common/clipboard";
import SensitivityLabel from "@/components/SensitivityLabel.vue";

export default Vue.extend({
  props: ["source"],
  components: {
    AppTableRow,
    SensitivityLabel,
  },
  setup() {
    return {
      CopyUrl,
    };
  },
});
